namespace GeniuzPOS.Product {
    export interface CsUnitRow {
        Id?: number;
        UnitId?: string;
        UnitName?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        FullName?: string;
    }

    export namespace CsUnitRow {
        export const idProperty = 'UnitId';
        export const nameProperty = 'FullName';
        export const localTextPrefix = 'Product.CsUnit';
        export const lookupKey = 'Product.CsUnit';

        export function getLookup(): Q.Lookup<CsUnitRow> {
            return Q.getLookup<CsUnitRow>('Product.CsUnit');
        }
        export const deletePermission = '1POSBASE:ข้อมูลหลัก:ข้อมูลอ้างอิงสินค้า:หน่วยนับ:Delete';
        export const insertPermission = '1POSBASE:ข้อมูลหลัก:ข้อมูลอ้างอิงสินค้า:หน่วยนับ:Modify';
        export const readPermission = '1POSBASE:ข้อมูลหลัก:ข้อมูลอ้างอิงสินค้า:หน่วยนับ:View';
        export const updatePermission = '1POSBASE:ข้อมูลหลัก:ข้อมูลอ้างอิงสินค้า:หน่วยนับ:Modify';

        export declare const enum Fields {
            Id = "Id",
            UnitId = "UnitId",
            UnitName = "UnitName",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            FullName = "FullName"
        }
    }
}
